export const TIME_TO_IDLE_IN_MINUTES = 20;
export const TIME_TO_SIGNOUT_AFTER_IDLE_IN_MINUTES = 10;
export const RESET_TIME = 'sde-technical-user-idle-timeout-time';
export const HAS_SIGNED_OUT = 'sde-technical-user-idle-timeout-has-timed-out';
